// Constants
import { RESET_STATE } from '../auth/constants';
import {
    TIMESHEET_TIMESHEET_ENTRIES_SET,
    TIMESHEET_TIMESHEET_ENTRIES_MERGE,
    TIMESHEET_TIMESHEET_ENTRIES_REMOVE,
    TIMESHEET_TIMESHEET_ENTRY_SET
} from './constants';

const initialState = {};

type State = {};

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case TIMESHEET_TIMESHEET_ENTRIES_SET:
            return action.payload;
        case TIMESHEET_TIMESHEET_ENTRIES_MERGE:
            return {
                ...state,
                ...action.payload
            };
        case TIMESHEET_TIMESHEET_ENTRY_SET:
            return {
                ...state,
                [action.payload.uuid]: action.payload
            };
        case TIMESHEET_TIMESHEET_ENTRIES_REMOVE: {
            const copy = Object.assign({}, state);
            action.payload.timesheetEntryUuids.forEach(timesheetEntryUuid => {
                delete copy[timesheetEntryUuid];
            });
            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
